import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { selectDelivery } from '@store/order/selectors';
import { AppLanguageCode } from '@project-types/AppLanguageCodes';
import { PricingModel } from '@api/types/PricingModel';
import { getFormattedPrice } from '@translations/functions';



interface LetterProps {
	price: PricingModel | null | undefined,
	country: AppLanguageCode,
}


const Letter = (props: LetterProps) => {
	const { price, country } = props;
	const { t } = useTranslation('forms');

	const delivery = useSelector(selectDelivery);
	const productPrice = price && delivery ? price.priceWithVat - delivery.price : 0;
	const productPriceNoVat = price && delivery ? price.priceNoVat - delivery.price : 0;

	if (!delivery) return (
		<></>	
	)

	return (
		<div className='order-summary-element letter-element'>
			<p>{t('footer.letter.text1')}</p>
			<p>{t('footer.letter.text2')}</p>
			<p>{t('footer.letter.text3')}</p>
			<p>{t('footer.letter.text4')}</p>
			<p>{t('footer.letter.text5')}</p>

			{price && price.priceNoVat > 0 &&
				<p className='with-margin'>{
					`${t('footer.letter.text6')}\u00a0${getFormattedPrice(country, productPrice)} ` +
					
					`(${getFormattedPrice(country, productPriceNoVat)}\u00a0${t('footer.withoutVat')}) ` +
					
					`${t('footer.letter.text7')} ${getFormattedPrice(country, price.priceWithVat)} ` +
					
					`(${getFormattedPrice(country, price.priceNoVat)}\u00a0${t('footer.withoutVat')}).`
				}</p>
			}
			{price && price.priceNoVat > 0 &&
				<p>{t('footer.letter.text8')}</p>
			}

			<p className='with-margin'>{t('footer.letter.text9')}</p>
			<p>{t('footer.letter.text10')}</p>

			<p className='with-margin'>{t('footer.letter.text11')}</p>

			<p className='with-margin'>{t('footer.letter.text12')}</p>
		</div>
	);
};

export default Letter;